// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<App />);

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { createClient } from "graphql-ws";
import {
  split,
  HttpLink,
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
} from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { startApolloReconciliation } from "./graphql/apolloReconciliation";
import { BrowserRouter } from 'react-router-dom';
import {
  GRAPHQL_WS_CANCEL_EXPECTED_CLUSTER_SWITCH,
  GRAPHQL_WS_AUTH_REVOKED,
  GRAPHQL_WS_EXPECTED_CLUSTER_SWITCH,
  GRAPHQL_WS_RECONNECTED,
  GRAPHQL_WS_TRANSPORT_ERROR,
} from "./graphql/realtimeEvents";
import {
  isAuthRevokedClose,
  retryWait,
  shouldRetryWebSocket,
} from "./graphql/realtimePolicy";
import { API_URLS } from "./graphql/apiUrls";

const environment = process.env.REACT_APP_ENV || "production";
const urls = API_URLS;

const httpLink = new HttpLink({
  uri: urls[environment].http,
  credentials: 'include',
});

// // Create a WebSocket link:
// const wsLink = new GraphQLWsLink(
//   createClient({
//     url: urls[environment].ws,
//     connectionParams: async () => {return {authentication: localStorage.getItem("authentication")}},
//   })
// );
let wsLink = null;
let wsClient = null;
let timedOut;
let count = 0;
let expectedClusterSwitch = false;

window.addEventListener(GRAPHQL_WS_EXPECTED_CLUSTER_SWITCH, () => {
  expectedClusterSwitch = true;
});
window.addEventListener(GRAPHQL_WS_CANCEL_EXPECTED_CLUSTER_SWITCH, () => {
  expectedClusterSwitch = false;
});
// Create a WebSocket link:

if(environment !== "test"){
  wsClient = createClient({
      url: urls[environment].ws,
      // Keep a connection retry loop alive during a prolonged Backend outage.
      // This is also what lets the manual chaos harness observe recovery.
      lazy: false,
      shouldRetry: (eventOrError) => shouldRetryWebSocket(eventOrError, expectedClusterSwitch),
      retryWait,
      retryAttempts: Infinity,
      keepAlive: 5000,
      on:{
        connected: () => {
          count = 0;
          expectedClusterSwitch = false;
          window.dispatchEvent(new Event(GRAPHQL_WS_RECONNECTED));
        },
        closed: (event) => {
          const code = Number(event?.code);
          if (code === 4403 && expectedClusterSwitch) {
            return;
          }
          if (isAuthRevokedClose(event)) {
            window.dispatchEvent(new CustomEvent(GRAPHQL_WS_AUTH_REVOKED, {
              detail: { code, reason: event?.reason || "" },
            }));
          } else {
            window.dispatchEvent(new CustomEvent(GRAPHQL_WS_TRANSPORT_ERROR, {
              detail: {
                phase: "closed",
                code,
                reason: event?.reason || "",
                expectedClusterSwitch,
              },
            }));
          }
        },
        ping: (received) => {
          if (!received) {
            timedOut = setTimeout(() => {
              if(count >= 6){
                window.location.reload();
                wsClient.terminate();
              }
              else{
                count++;
              }
            }, 2000);
          };
        },
        pong: (received) => {
          if (received) {
            clearTimeout(timedOut);
            count = 0;
          };
        },
        error: (error) => {
          window.dispatchEvent(new CustomEvent(GRAPHQL_WS_TRANSPORT_ERROR, {
            detail: {
              phase: "error",
              message: error?.message || String(error || "WebSocket transport error"),
              expectedClusterSwitch,
            },
          }));
          const authority = sessionStorage.getItem("authority");
          if(count >= 6){
            if(authority !== "2"){
              alert("lost connection");
              window.location.reload();
              wsClient.terminate();
            }
          }
          else{
            count++;
          }
        },
      },
    });
  wsLink = new GraphQLWsLink(wsClient);
  if (environment === "chaos" && process.env.REACT_APP_CHAOS_TEST_MODE === "true") {
    window.__ISHIELD_CHAOS__ = {
      forceWebSocketReconnect: () => wsClient.terminate(),
    };
  }
}



// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const splitLink = wsLink
  ? split(
      ({ query }) => {
        const definition = getMainDefinition(query);
        return (
          definition.kind === "OperationDefinition" &&
          definition.operation === "subscription"
        );
      },
      wsLink,
      httpLink,
    )
  : httpLink;

const cache = new InMemoryCache({
  // typePolicies: {
  //   Query: {
  //     keyFields:[],
  //     fields: {
  //       aliveTargets: {
  //         keyArgs:false,
  //         merge(existing, incoming) {
  //           console.log('merge')
  //           console.log(existing)
  //           console.log(incoming)
  //           return [...incoming]
  //         },
  //       }
  //     }
  //   }
  // }
});

const client = new ApolloClient({
  link: splitLink,
  cache: cache,
});

// Redis health recovery and WebSocket lifecycle events trigger reconciliation
// from the authoritative Backend/MongoDB projection. A periodic fallback can
// still be enabled by passing intervalMs when needed.
startApolloReconciliation(client);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ApolloProvider client={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>
  /* </React.StrictMode> */
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
